<div class="p-4 text-white bg-primary">
    <h2 class="font-bold">
        {{ "PRINT.INTERESTED_IN_QUOTATION.QUESTION" | translate }}
    </h2>
</div>

<div class="p-4 flex justify-evenly">
    <button type="submit" class="w-min px-3 py-1 bg-secondary text-white font-bold rounded float-end" (click)="dialogRef.close(true)" > {{ "GLOBAL.YES" | translate }} </button>
    <button type="submit" class="w-min px-3 py-1 bg-secondary text-white font-bold rounded float-end" (click)="dialogRef.close(false)" > {{ "GLOBAL.NO" | translate }} </button>
</div>